'use client';
import Link from 'next/link';

import { BigButtonCardProps } from './types';

import IconArrow from '@/assets/icons/iconArrow.svg';
import { classNames } from '@/shared/lib/classNames/classNames';

export const BigButtonCard = ({
  titleId,
  title,
  descriptionId,
  description,
  imageSrc,
  children,
  href,
  variant = 'medium',
  alt,
  customClassNames,
  titleLogoSrc,
}: BigButtonCardProps) => {
  return (
    <>
      <Link
        href={`${href}`}
        className={classNames({
          cls: 'group rounded-20 bg-surface-base-secondary relative box-border h-[560px] transition-transform duration-300 hover:scale-[1.02]',
          mods: {
            'w-[358px] grow max-sm:h-[512px] max-sm:w-full':
              variant === 'medium',
            'w-[768px] grow max-sm:mt-[62px] max-sm:h-[344px] max-sm:w-full':
              variant === 'large',
          },
          additional: [customClassNames?.main],
        })}
      >
        <div
          className={classNames({
            cls: 'rounded-20 bg-surface-base-secondary absolute top-0 flex h-full w-full flex-col justify-start from-white/20 to-white/5 p-8 hover:inset-0 hover:bg-linear-to-b',
            additional: [customClassNames?.mainWrapper],
          })}
        >
          <img
            src={imageSrc}
            className={classNames({
              mods: {
                'absolute top-2 right-0 left-0 mx-auto w-[352px]':
                  variant === 'medium',
                'pointer-events-none absolute top-[-39%] left-0 max-sm:top-[-42%]':
                  variant === 'large',
              },
              additional: [customClassNames?.img],
            })}
            alt={alt}
          />
          <div
            className={classNames({
              cls: 'absolute top-[66.4%]',
              mods: {
                'max-sm:top-[50%]': variant === 'large',
              },
              additional: [customClassNames?.contentWrapper],
            })}
          >
            <div className="flex items-start gap-2">
              {titleLogoSrc && <img src={titleLogoSrc} alt="title-logo" />}
              <p
                id={titleId}
                className={classNames({
                  cls: 'text-[24px] leading-[32px] tracking-[-1.5%] max-sm:text-[20px]',
                  additional: [customClassNames?.title],
                })}
              >
                {title}
                <IconArrow
                  className={classNames({
                    cls: 'w-10 transition-transform duration-300 group-hover:-rotate-45 max-sm:w-8',
                    additional: [customClassNames?.iconArrow],
                  })}
                />
              </p>
            </div>
            <div
              id={descriptionId}
              className={classNames({
                cls: 'text-base font-normal tracking-tight max-sm:text-sm',
                mods: {
                  'w-[304px]': variant === 'medium',
                  'w-[450px] max-sm:w-[304px]': variant === 'large',
                },
                additional: [customClassNames?.description],
              })}
            >
              {description}
            </div>
            {children}
          </div>
        </div>
      </Link>
    </>
  );
};
